import {KVPair, ListPage, Loss, Sortable} from "../../models/types";
import {useTranslation} from "react-i18next";
import {useLoggedUser} from "../../hooks/user";
import {TablePagination} from "../commons/table-pagination/table-pagination";
import {DataTable} from "../commons/data-table/data-table";
import {createLossColumns} from "./columns";

interface Props {
    hidePagination?: boolean;
    page?: ListPage<Loss>;
    loadPage: (page: number, pageSize?: number, filtering?: KVPair[], sorting?: string[]) => void;
    sort?: (field: string) => void;
    sortInfo?: Sortable[];
    onDeleteSingle: (loss: Loss) => void;
}

export function LossTable(props: Props) {
    const {t} = useTranslation();
    const user = useLoggedUser({});

    const columns = createLossColumns(props.onDeleteSingle, (key) => t(key) as string);

    if (!props.page) {
        return null;
    }

    return (
        <div>
            <DataTable
                columns={columns}
                data={props.page.results}
                userRole={user?.role}
                sortInfo={props.sortInfo}
                onSort={props.sort}
                getRowKey={(loss) => loss.id}
            />
            {!props.hidePagination && (
                <TablePagination page={props.page} loadPage={props.loadPage}/>
            )}
        </div>
    );
}
